import React from "react";

export const useSessionStorage = () => {
    const [value, setValue] = React.useState<string | null>(null);
  
    const setItem = (key: string, value: string) => {
      sessionStorage.setItem(key, value);
      setValue(value);
    };
  
    // Ren læsning - må ikke sætte state, da getItem kaldes under render (fx via getCurrentGuildStats)
    const getItem = (key: string) => {
      return sessionStorage.getItem(key);
    };
  
    const removeItem = (key: string) => {
      sessionStorage.removeItem(key);
      setValue(null);
    };
  
    return { value, setItem, getItem, removeItem };
  };